import { render, staticRenderFns } from "./AuthError.vue?vue&type=template&id=4c9778f4&scoped=true"
import script from "./AuthError.vue?vue&type=script&lang=js"
export * from "./AuthError.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c9778f4",
  null
  
)

export default component.exports